<template>
  <Layout v-if="type === 'admin'">
      <div>
      <div class="bg-white">
      <div class=" mx-auto sm:px-6  lg:px-6 lg:flex lg:items-center lg:justify-between">
          <div class="flex-shrink-0 h-24 w-24">
          <img
            class="h-24 w-24 rounded-full"
            src="../assets/GraceNew.png"
            alt=""
            />
          </div>
           <!-- <button 
          type="button"
          v-on:click="createArray(); updateSermon();"
          class="relative inline-flex items-center px-5 py-4 border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-red-600 focus:outline-none transition duration-150 ease-in-out"
          >
          <img class="h-6 w-6" src="../assets/save.png" alt />
          <a  class="absolute inset-0 z-6 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
         <h1 class=tracking-wider >Update Sermon</h1>
          </a>
        </button>-->
   
              <h2 v-if="isMember === 'NO'"  class="text-xl leading-9 font-extrabold tracking-tight text-blue-400 sm:text-xl md:text-2xl lg:text-2xl sm:leading-10 justify-start text-left">
            Add A Grace Visitor <a style="color: #C38437" class="text-2xl font-extrabold text-green-700 sm:text-xl md:text-2xl lg:text-2xl justify-start text-left"></a>
            <br />
          </h2>
         
    
        </div>
      </div>
    </div>
    {{errorMessage}}
        <div class="text-xl text-left text-black">
    <p v-if="errors.length">
      <b></b>
      <ul>
        <div class="text-red-600 text-left">
        <li v-for="error in errors" :key=error>{{ error }}</li>
        </div>
      </ul>
    </p>
    </div>
    <div
      class="bg-white shadow overflow-hidden sm:rounded-lg mt-2"
      v-if="admin"
    >
  
      <div>
        <dl>
            <BaseButton v-on:click="clear();"  >Clear</BaseButton>
                 <div
            class="bg-gray-50 px-4  py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0 sm:pt-0 md:pt-4 lg:pt-4">
          Date Visited :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <BaseInput label="" type="date"  placeholder="..." v-model="visitedDate" />
            </dd>
          </div>
            <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Vistor First Name :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="100" v-model="vfirstName" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Visitor First Name..."></textarea>
            </dd>
          </div>
             <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Vistor Last Name :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="100" v-model="vlastName" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Visitor Last Name..."></textarea>
            </dd>
          </div>
              <div
            class="bg-gray-50 px-4  py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0 sm:pt-0 md:pt-4 lg:pt-4">
          Visitor Date of Birth :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <BaseInput label="" type="date"  placeholder="..." v-model="vbirthDate" />
            </dd>
          </div>
         
             <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Email Address :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="200" v-model="vemailAddress" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Visitor Email Address..."></textarea>
            </dd>
          </div>
          
              <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Mobile Number :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="12" type="number" v-model="vmobileNo" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Visitor Mobile Number..."></textarea>
            </dd>
          </div>
          
               <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           How did you hear about us? :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="2000" v-model="hearAbout" class ="appearance-none rounded-none resize-none relative h-32 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="How did you hear about us?..."></textarea>
            </dd>
          </div>
           <div 
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0">
          Can we Pray for you? :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
            <select
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5"
              v-model="prayYou"
            >
              <option disabled value>...</option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </select>
            </dd>
          </div>
               <div 
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0">
          Would you like the Pastor to visit You? :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
            <select
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5"
              v-model="pastorVisit"
            >
              <option disabled value>...</option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </select>
            </dd>
          </div>
               <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Additional Information :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="2000" v-model="additionalInformation" class ="appearance-none rounded-none resize-none relative h-32 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Additional Information..."></textarea>
            </dd>
          </div>
      
         <div class="pl-4 ml-2 pt-2 bg-gray-50"></div>
           
              <BaseButton   v-on:click="checkForm1(); getFullName();  addNumber();  createArray(); addMember();  "  >Add Grace Visitor</BaseButton>
         <!-- <div v-if="admin.document"
            class="bg-gray-50 px-4 py-0 pt-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Email Manual
            </dt>
            <dd
              class="py-3 px-4 mt-1 text-lg leading-5 text-orange-600 sm:mt-0 sm:col-span-2"
            >
            <input type="email" class="w-80 h-8" id="email" name="user_email" v-model="email" placeholder="Your email.." required>
            <input type="submit" value="Send Now" class=" inline-flex text-xl items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-900 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-blue-600 transition duration-150 ease-in-out">
            </dd>
          </div> -->
          <div>

       </div>
          <div class="pl-10"></div>
        </dl>
      </div>
    </div>

       
  </Layout>
</template>

<script>
import Layout from "./layouts/Main.vue";
//import BaseFileUploader from "../components/BaseFileUploader";
//import BaseFileUploader from "../components/BaseFileUploader";
import BaseButton from "../components/BaseButton";
import BaseInput from "../components/BaseInput";
//import emailjs from 'emailjs-com';
import { mapGetters } from "vuex";

export default {
  name: "adminaddmember",
  components: { Layout, BaseButton, BaseInput},
  data() {
    return {
      admin: {},
      member : "",
      businessPartner: "",
      //fileUrl: "",
      array : "",
      sermonLink: "",
      pastorVisit: "",
      timer100: "",
      visitedDate: "",
      //children:"0",
      marriageStatus :  "",
      vfirstName : "",
      prayYou: "",
      spouse: "",
      children: "0",
      childrenNames: ".",
      hearAbout: "",
      isMember : "NO",
      baptismDateElse: "",
      vlastName : "",
      //memberNo : "",
      address: "",
      vbirthDate : "",
      vemailAddress : "",
      vfullName : "",
      vmobileNo : "",
      otherTel : "",
      memberNo : "",
      baptismDate : "",
      membershipDate : "",
      additionalInformation : "",
      baptizedGrace : "",
      errors: [],
     

    };
  },
  created() {
    this.type = this.currentUserData.userType;
    this.userStatus = this.currentUserData.status;
    if (this.type !== "admin" ) {
      this.$router.push({
        name: "Home",
      });
    }
    this.getMemberNo();
    
    //this.getSermonID();
    //this.getEmployeeCertificate();
    
  },
  mounted(){

    //this.getLicenseData();

  },
  computed: {
    ...mapGetters(["currentUserData"]),
  },
  methods: {
      getMemberNo() {
      const userData = this.$db
        .collection("memberID")
        //.where("user", "==", this.$auth.currentUserData.user);
        .where("active", "==",'yes')
        
      userData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.member = data;
        });
      });
    },
    getFullName(){
      this.vfullName = this.vfirstName + ' ' + this.vlastName
      
    },
      createArray(){
      if(!this.array)
      this.array = []

      for (let i = 0; i < this.vfullName.length; i++){
      this.array.push(this.vfullName.slice(0,i+1).toLowerCase());
      }
    },
    addMember() {
     
    
      
        this.$db.collection("visitors").add({
          vistorNo : this.memberNo,
          vfirstName : this.vfirstName,
          vlastName : this.vlastName,
          vfullName : this.vfullName,
          vemailAddress : this.vemailAddress,
          vistorDate : this.visitedDate,
          vbirthDate: this.vbirthDate,
          vmobileNo : this.vmobileNo,
          additionalInformation : this.additionalInformation,
          addedBy: this.currentUserData.email,
          hearAbout: this.hearAbout,
          prayYou: this.prayYou,
          pastorVisit: this.pastorVisit,
          vsearch: this.array,
          activeMember : "NO",
          isMember: "NO",
          isVisitor: "YES",
          pastorFollowUp: "NO",
        });

        window.confirm(
          "Visitor was added successfully."
        );
        this.updateMemberID();
        this.redirect();
      },
     
    
    
    addNumber() {
       this.memberNo = this.member.visitorID+=1;
     },
      updateMemberID(){
      this.$db
        .collection("memberID")
        .doc(this.member.id)
        .update({
          visitorID: this.memberNo,
        })
        //.then(() => this.getPendingApprovals());
        //this.$router.push({
        //name: "dashboard",})
    },
    clear(){
      this.visitedDate = "",
      this.vfirstName =  "",
      this.vlastName =  "",
      this.vbirthDate = "",
      this.vemailAddress = "",
      this.vmobileNo = "",
      this.hearAbout = "",
      this.prayYou = "",
      this.pastorVisit = "",
      this.additionalInformation = "",
      this.errors = ""

    },
    getSermonID() {
      //const employer = [];
      const certData = this.$db
        .collection("sermonLinks")
        .where("sermonID", "==", this.admin.sermonID)
        
        
      certData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.sermonLink = data;
        });
        //this.removeTicket();
        //this.deleteAttachPlanning();
      });
    },
  

    checkForm: function (e) {
      this.errors = [];

       
        if (!this.firstName) {
          this.errors.push("First Name is required...");
        }
        if (!this.lastName) {
          this.errors.push("Last Name is required...");
        }
        if (!this.address) {
          this.errors.push("Address is required...");
        }
        if (!this.birthDate) {
          this.errors.push("birth Date is required...");
        }
        if (!this.marriageStatus) {
          this.errors.push("Marriage Status is required...");
        }
        if (!this.emailAddress) {
          this.errors.push("Email Address is required...");
        }
        if (!this.mobileNo) {
          this.errors.push("Mobile is required...");
        }
        if (!this.otherTel) {
          this.errors.push("Other Tel is required...");
        }
        if (!this.baptizedGrace) {
          this.errors.push("Baptized at Grace is required...");
        }
       
        if (!this.membershipDate) {
          this.errors.push("Membership Date is required...");
        }
        if (!this.errors.length) {
          return true;
        }

        e.preventDefault();
      },
          checkForm1: function (e) {
      this.errors = [];

       
        if (!this.vfirstName) {
          this.errors.push("First Name is required...");
        }
        if (!this.vlastName) {
          this.errors.push("Last Name is required...");
        }
    
  

        if (!this.errors.length) {
          return true;
        }

        e.preventDefault();
      },
    updateSermonLink() {
      this.$db
        .collection("sermonLinks")
        .doc(this.sermonLink.id)
        .update({
          //clientName: this.company.clientName.toLowerCase(),
         document: this.sermonLink.document,
        
        });
      //this.pages.homeJobSeeker = this.homeJobSeeker,
      window.confirm("Sermon Link Has been updated.");
       this.timer100 = setTimeout(this.getSermonID, 1000)
    },


    redirect() {
      this.$router.push({
      name: "dashboard",
      });
    },

  }
};
</script>
